import { Injectable } from '@angular/core';
import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from '@angular/common/http';
import { Observable } from 'rxjs';
import { appConfig } from '../../init/getAppConfig';
import { getChatApiBaseUrl } from '../../utils/getChatApiBaseUrl';

@Injectable()
export class UcxApiEnvRequestInterceptor implements HttpInterceptor {
  intercept(
    request: HttpRequest<unknown>,
    next: HttpHandler
  ): Observable<HttpEvent<unknown>> {
    const env = appConfig.apiEnv;
    if (env && request.url.includes(getChatApiBaseUrl())) {
      const newReq = request.clone({
        headers: request.headers.set('env', env),
      });
      return next.handle(newReq);
    }
    return next.handle(request);
  }
}
